import { useMemo } from "react";
import { resources } from "@constants/hardcoded-strings";
import { WorkflowReportCompletionRatesOverTimeResponse, WorkflowReportCompletionRateDataType } from "@idw-types/data/reports";
import { CardContainer } from "../../../common/card-container/card-container";
import { ContentPageBody } from "../../../common/content-page-body/content-page-body";
import { ContentPageHeader } from "../../../common/content-page-header/content-page-header";
import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons/faQuestionCircle";
import { WorkflowReportCompletionRatesPieChart } from "./workflow-report-completion-rates-pie-chart/workflow-report-completion-rates-pie-chart";
import { WorkflowReportCompletionRatesOverTimeAreaChart } from "./workflow-report-completion-rates-over-time-area-chart/workflow-report-completion-rates-over-time-area-chart";
import { WorkflowReportSearchFiltersState } from "@idw-types/state/workflow-report-state";
import styles from "./workflow-report-completion-rates-container.less";
import { WorkflowLegendContainer } from "../workflow-legend-container/workflow-legend-container";
import { WORKFLOW_REPORT_COMPLETION_RATES_LEGEND_ITEMS } from "@constants/workflow-report";
import { LoadingIndicator } from "@containers/common/loading-indicator/loading-indicator";

type WorkflowReportCompletionRatesContainerProps = {
    completionRatesResponse: WorkflowReportCompletionRateDataType;
    completionRatesOverTimeResponse: WorkflowReportCompletionRatesOverTimeResponse;
    searchFilters: WorkflowReportSearchFiltersState;
    isLoading: boolean;
};

export const WorkflowReportCompletionRatesContainer = (props: WorkflowReportCompletionRatesContainerProps) => {
    const { completionRatesResponse, completionRatesOverTimeResponse, searchFilters, isLoading } = props;

    const { totalCount, completeCount } = useMemo(() => {
        let completeCount = 0;
        let totalCount = 0;
        if (completionRatesResponse) {
            completeCount = completionRatesResponse.complete;
            totalCount = completionRatesResponse.complete + completionRatesResponse.incomplete;
        }

        return { totalCount, completeCount };
    }, [completionRatesResponse]);

    const completionRatesTooltip = useMemo(() => {
        const renderTooltip = (props: any) => {
            return <Tooltip {...props}>{resources.pages.workflowReport.sections.completionRates.tooltip}</Tooltip>
        }
        return (
            <OverlayTrigger overlay={renderTooltip} placement={"auto"}>
                <div><FontAwesomeIcon icon={faQuestionCircle} /></div>
            </OverlayTrigger>
        );
    }, []);

    return (
        <CardContainer>
            <ContentPageHeader title={resources.pages.workflowReport.sections.completionRates.title} headerButton={completionRatesTooltip} />
            <ContentPageBody isMaxWidth={true}>
                {isLoading && <LoadingIndicator title={resources.common.loadingIndicatorText} />}
                {(!isLoading && completionRatesResponse && completionRatesOverTimeResponse) && <><span id="workflow-report-completion-rates-description" dangerouslySetInnerHTML={{ __html: resources.pages.workflowReport.sections.completionRates.description(totalCount, completeCount) }} />
                    {totalCount > 0 && (
                        <div className={styles.graphContainer}>
                            <div className={styles.workflowReportCompletionRatesPieChartContainer}>
                                <WorkflowReportCompletionRatesPieChart
                                    completionRatesResponse={completionRatesResponse}
                                    searchFilters={searchFilters}
                                />
                                <div className={styles.workflowReportCompletionRatesOverTimeAreaLegend}>
                                    <WorkflowLegendContainer
                                        items={WORKFLOW_REPORT_COMPLETION_RATES_LEGEND_ITEMS}
                                    />
                                </div>
                            </div>
                            <div className={styles.workflowReportCompletionRatesOverTimeAreaChartContainer}>
                                <WorkflowReportCompletionRatesOverTimeAreaChart
                                    completionRatesOverTimeResponse={completionRatesOverTimeResponse}
                                    searchFilters={searchFilters}
                                />
                            </div>
                        </div>
                    )}
                </>}
            </ContentPageBody>

        </CardContainer>
    );
};